/**
 * @generated SignedSource<<a3dae0d3eddaa91789cff585384f7e0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Answers_answers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSeparator",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Answer_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFilterConditionnallyHiddenAnswers_answers"
    }
  ],
  "type": "AnswerBase",
  "abstractKey": "__isAnswerBase"
};

node.hash = "888b301cea46e53043235919fe315b49";

module.exports = node;
